<div class="search-container">
  <app-suggestion-search-input
    [id]="'list-group-search-input'"
    [inputLabel]="inputSearchLabel"
    [placeholder]="'Buscar'"
    [autocompleteConfig]="autoCompleteConfig"
    (searchInput)="onSearchInput($event)"
    [disabled]="isLoading"
    >
    <ng-template appSearchInputOptionTemplate let-option>
      <span style="font-style: italic">{{ option }}</span>
    </ng-template>
  </app-suggestion-search-input>

  @if (showAdminActions) {
    <app-button
      [id]="'list-group-btn-add'"
      (click)="handleNewWalletShortcutClick()"
      [buttonStyle]="'danger'"
      size="large"
      icon="add"
      title="Incluir cartera"
      i18n-title="@@addWallet"
      >
      <span i18n="@@include">Incluir</span>
    </app-button>
  }
</div>

<app-generic-table
  [id]="'list-group-table'"
  [config]="tableConfig"
  [data]="wallets"
  [isLoading]="isLoading"
  [noDataMessage]="noDataMessage"
  [page]="page"
  [pageSize]="pageSize"
  [totalRegisters]="totalPage"
  (pageChange)="changePage($event)"
  >
  <ng-template appTableCell="_icon" let-wallet>
    @if (personType === 'COMPANY') {
      <div>
        <img
          src="{{ urlAssets }}/icons/carteras-select-company.png"
          alt="Estatica"
          style="max-width: 30px"
          />
        </div>
      }
      @if (personType === 'PERSON') {
        <div>
          <img
            src="{{ urlAssets }}/icons/carteras-estaticas.png"
            alt="Estatica"
            style="max-width: 30px"
            />
          </div>
        }
      </ng-template>

      <ng-template appTableCell="name" let-wallet>
        <span
          (click)="sendInfoRedirect(wallet)"
          style="color: black; text-decoration: none; background-color: none; cursor: pointer"
          >
          <span
            mat-menu-item
            role="button"
            style="font-family: 'Open Sans', sans-serif; font-size: 14px"
            >
            {{ wallet.name }}</span
            >
          </span>
        </ng-template>

        <ng-template appTableCell="_actions" let-wallet>
          <div class="action-column">
            <a
              (click)="handleDelete(wallet)"
              [ngClass]="{ inactive: wallet.base }"
              matTooltip="Excluir Carteira"
              i18n-matTooltip="@@deleteWallet"
              matTooltipClass="custom-tooltip"
              >
              <em class="far fa-trash-alt"></em>
            </a>
            @if (!wallet.isAlert30Days) {
              <a
                (click)="handleEdit(wallet)"
                [ngClass]="{ inactive: wallet.base }"
                matTooltip="Editar Carteira"
                i18n-matTooltip="@@editWallet"
                matTooltipClass="custom-tooltip"
                >
                <em class="fas fa-pencil-alt"></em>
              </a>
            }
            <a
              (click)="toggleFavorite(wallet)"
              [matTooltip]="wallet.favorite ? getRemoveFavoriteTooltip() : getAddFavoriteTooltip()"
              matTooltipClass="custom-tooltip"
              >
              <em [class]="wallet.favorite ? 'fas fa-star' : 'far fa-star'"></em>
            </a>
            <a
              (click)="manageAlerts(wallet)"
              matTooltip="Gerenciar Alertas e Notificações"
              i18n-matTooltip="@@manageAlerts"
              matTooltipClass="custom-tooltip"
              >
              <em class="far fa-bell"></em>
            </a>
            <a
              (click)="openWalletTrend(wallet)"
              matTooltip="Análise de tendência da carteira"
              i18n-matTooltip="@@walletTrendAnalysisTooltip"
              matTooltipClass="custom-tooltip"
              >
              <em class="fas fa-chart-line"></em>
            </a>
          </div>
        </ng-template>
      </app-generic-table>
